import { render, staticRenderFns } from "./form-desconto.vue?vue&type=template&id=b48b50b4"
import script from "./form-desconto.vue?vue&type=script&lang=js"
export * from "./form-desconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports